<template>
  <reports-table
    module="payroll"
    name="payroll_summary"
    :filters="serializedFilters"
    :exclude-page-params="true"
  >
    <template #default="{generateReport}">
      <oxd-table-filter :filter-title="$t('payroll.payroll_summary_report')">
        <oxd-form @submit-valid="generateReport" @reset="generateReport">
          <oxd-form-row>
            <oxd-grid :cols="4" class="orangehrm-full-width-grid">
              <oxd-grid-item>
                <oxd-input-group
                  :label="$t('leave.generate_for')"
                  :classes="{wrapper: '--grouped-field'}"
                >
                  <oxd-input-field
                    v-model="filters.type"
                    type="radio"
                    :option-label="$t('payroll.overall')"
                    value="overall"
                  />
                  <oxd-input-field
                    v-model="filters.type"
                    type="radio"
                    :option-label="$t('payroll.department')"
                    value="department"
                  />
                </oxd-input-group>
              </oxd-grid-item>
            </oxd-grid>
          </oxd-form-row>

          <oxd-form-row>
            <oxd-grid :cols="4" class="orangehrm-full-width-grid">
              <oxd-grid-item>
                <oxd-input-field
                  v-model="filters.fromDate"
                  type="date"
                  :label="$t('general.from_date')"
                />
              </oxd-grid-item>
              <oxd-grid-item>
                <oxd-input-field
                  v-model="filters.toDate"
                  type="date"
                  :label="$t('general.to_date')"
                />
              </oxd-grid-item>
              <oxd-grid-item>
                <oxd-input-field
                  v-model="filters.locations"
                  :label="$t('general.location')"
                  :options="locations"
                  type="multiselect"
                  value="-- Select --"
                />
              </oxd-grid-item>
              <oxd-grid-item>
                <oxd-input-field
                  v-model="filters.subunit"
                  type="select"
                  :label="$t('general.sub_unit')"
                  :options="subunits"
                />
              </oxd-grid-item>
            </oxd-grid>
          </oxd-form-row>

          <oxd-divider />

          <oxd-form-actions>
            <required-text />
            <oxd-button
              type="reset"
              display-type="ghost"
              :label="$t('general.reset')"
              @click="onClickReset"
            />
            <oxd-button
              type="submit"
              display-type="secondary"
              class="orangehrm-left-space"
              :label="$t('general.generate')"
            />
          </oxd-form-actions>
        </oxd-form>
      </oxd-table-filter>
      <br />
    </template>
  </reports-table>
</template>

<script>
import {computed, ref} from 'vue';
import ReportsTable from '@/core/components/table/ReportsTable';

const defaultFilters = {
  type: 'overall',
  fromDate: null,
  toDate: null,
  subunit: null,
  locations: [],
};

export default {
  components: {
    'reports-table': ReportsTable,
  },
  props: {
    locations: {
      type: Array,
      default: () => [],
    },
    subunits: {
      type: Array,
      default: () => [],
    },
  },

  setup() {
    const filters = ref({
      ...defaultFilters,
    });
    const serializedFilters = computed(() => {
      return {
        fromDate: filters.value.fromDate,
        toDate: filters.value.toDate,
        subUnitId: filters.value.subunit?.id,
        locationIds: filters.value.locations.map((item) => item.id),
        groupBy: filters.value.type,
      };
    });

    return {
      filters,
      serializedFilters,
    };
  },

  methods: {
    onClickReset() {
      this.filters = {...defaultFilters};
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep(.--grouped-field) {
  display: flex;
  flex-wrap: wrap;
  @include oxd-respond-to('md') {
    flex-wrap: nowrap;
  }
}

.orangehrm-leave-filter {
  display: flex;
  align-items: center;
  white-space: nowrap;

  &-text {
    font-size: $oxd-input-control-font-size;
    margin-right: 1rem;
  }
}
</style>
